module.exports = __webpack_public_path__ + "img/login_bg.6fa140b6.png";